export default __webpack_public_path__ + "static/media/redsweater.cc98aaa1.jpeg";